/**
 * BETA — Admin endpoints. The demo never has an ADMIN_PHARMAKON user, but
 * background polls and any direct nav must still get a graceful response.
 */
const empty = () => ({ data: [], total: 0 });
const success = () => ({ success: true });

export function register(route) {
  route("GET", "/admin/balance", () => ({ balance: 0, currency: "DZD" }));
  route("GET", "/admin/kpis", () => ({
    nb_pharmacies: 142,
    nb_actives: 128,
    ca_total_ttc: 24500000,
    nb_licences_actives: 128,
  }));
  route("GET", "/admin/pharmacies", empty);
  route("GET", "/admin/pharmacies/:id", () => ({ data: null }));
  route("PATCH", "/admin/pharmacies/:id", success);
  route("PATCH", "/admin/pharmacies/:id/statut", success);
  route("POST", "/admin/pharmacies/:pharmacie_id/checkout", () => ({ success: true, url: "https://demo.chargily.io" }));
  route("GET", "/admin/pharmacies/:pharmacie_id/licences", empty);
  route("GET", "/admin/fournisseurs", empty);
  route("GET", "/admin/fournisseurs/:id", () => ({ data: null }));
  route("PATCH", "/admin/fournisseurs/:id/statut", success);
  route("GET", "/admin/laboratoires", empty);
  route("PATCH", "/admin/laboratoires/:id/statut", success);
  route("GET", "/admin/cnas", empty);
  route("GET", "/admin/cnas/stats", () => ({ count: 0, last_import: null }));
  route("GET", "/admin/cnas/diff", () => ({ added: [], updated: [], removed: [] }));
  route("POST", "/admin/cnas/import", () => ({ success: true, imported: 0 }));
  route("PATCH", "/admin/cnas/:id", success);
  route("DELETE", "/admin/cnas/:id", success);
  route("GET", "/admin/licences", empty);
  route("PATCH", "/admin/licences/:id", success);
  route("GET", "/admin/licences/:post_licence_id/modules", empty);
  route("GET", "/admin/billing", empty);
  route("GET", "/admin/billing/pricing", () => ({ plans: [] }));
  route("PUT", "/admin/billing/pricing", success);
  route("GET", "/admin/billing/pricing/historique", () => []);
  route("GET", "/admin/monitor/health", () => ({
    status: "OK",
    uptime_seconds: 2592000,
    db_ok: true,
    redis_ok: true,
  }));
  route("GET", "/admin/monitor/audit", empty);
  route("GET", "/admin/monitor/audit/suspicious", empty);
  route("GET", "/admin/monitor/errors", empty);
  route("GET", "/admin/monitor/security", empty);
  route("GET", "/admin/monitor/security/failed-logins", empty);
  route("GET", "/admin/monitor/users", empty);
  route("POST", "/admin/monitor/users/:id/deactivate", success);
  route("POST", "/admin/monitor/users/:id/reactivate", success);
  route("POST", "/admin/monitor/users/:id/reset-password", success);
  route("POST", "/admin/monitor/users/:id/revoke-sessions", success);
  route("GET", "/nomenclature", empty);
  // /nomenclature/search is handled by ./nomenclature.js with a real catalogue.
  route("GET", "/nomenclature/stats", () => ({ count: 0 }));
  route("GET", "/nomenclature/diff", () => ({ added: [], updated: [], removed: [] }));
  route("GET", "/nomenclature/:id", () => ({ data: null }));
}
